export default "__VITE_ASSET__BUbRnwUl__"